<template>
  <div>
    <div class="info">
      <div class="head">
        <div class="title">{{userType==2 ?'企业': '行政事业单位'}}抵押贷款信息采集</div>
        <div class="tool">
          <div @click="sumbitCompany(1)">下一步</div>
          <!-- <div @click="sumbitCompany(2)">提交页面审核</div> -->
        </div>
      </div>
      <div class="h_bg p50">
        <h3>企业基本信息</h3>
        <span>带“*”号为必填项</span>
      </div>
      <el-form class='m50' ref="formRef" :rules="rules" :model="companyInfoEntity" label-width="180px" label-position="left" size="mini">
        <el-form-item :label="userType==2 ?'企业名称':'单位名称'">
          <div>{{companyInfoEntity.companyName}}</div>
        </el-form-item>
        <el-form-item label="统一信用代码证号">
          <div>{{companyInfoEntity.unifiedCreditCode}}</div>
        </el-form-item>
        <el-form-item label="注册地址" prop='companyAddress'>
          <el-input v-model="companyInfoEntity.companyAddress" placeholder="请输入企业地址"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="contactPerson">
          <el-input v-model="companyInfoEntity.contactPerson" placeholder="请输入联系人"></el-input>
        </el-form-item>
        <el-form-item label="联系地址" prop="contactAddress">
          <el-input v-model="companyInfoEntity.contactAddress" placeholder="请输入联系地址"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="contactNumber">
          <el-input v-model="companyInfoEntity.contactNumber" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <!-- <el-form-item label="统一信用代码证号" prop="unifiedCreditCode">
          <el-input v-model="companyInfoEntity.unifiedCreditCode" placeholder="请输入统一信用代码证号"></el-input>
        </el-form-item> -->
        <el-form-item label="成立时间" prop="establishTime">
          <el-date-picker
            @change="changeEstablishTime($event)"
            v-model="companyInfoEntity.establishTime"
            value-format='yyyy-MM-dd'
            type="date"
            placeholder="请选择成立时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="主要负责人姓名" prop="principalName">
          <el-input v-model="companyInfoEntity.principalName" placeholder="请输入负责人姓名"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="identityNumber">
          <el-input v-model="companyInfoEntity.identityNumber" placeholder="请输入负责人身份证号"></el-input>
        </el-form-item>
        <el-form-item label="负责人电话" prop="principalNumber">
          <el-input v-model="companyInfoEntity.principalNumber" placeholder="请输入负责人电话"></el-input>
        </el-form-item>
        <el-form-item label="申请贷款金额" prop="loanAmount">
          <el-input v-model="companyInfoEntity.loanAmount" @keyup.native="changeCode('loanAmount')" placeholder="请输入">
            <template slot="append">万元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="希望申请的银行" prop="bankId">
          <el-select v-model="companyInfoEntity.bankId" multiple placeholder="请选择" @change="changeBank($event)">
            <el-option
              v-for="item in bankList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="企业主营业务" prop="mainBusiness">
          <el-input v-model="companyInfoEntity.mainBusiness" placeholder="请输入企业主营业务">
          </el-input>
        </el-form-item>
        <el-form-item label="营业时间段" prop="businessWeek">
          <div class="business-hours">
            <div class="bussiness-item">
              <el-select v-model="companyInfoEntity.businessWeekStart" size="small" placeholder="请选择" @change="changeBusinessWeek">
                <el-option
                  v-for="(item, ind) in businessWeekOptions"
                  :key="ind"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
              <span class="lr-padding">至</span>
              <el-select v-model="companyInfoEntity.businessWeekEnd" size="small" placeholder="请选择" @change="changeBusinessWeek">
                <el-option
                  v-for="(item, ind) in businessWeekOptions"
                  :key="ind"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </div>
            <div class="bussiness-item">
              <span class="item-span">上午</span>
              <el-time-picker
                is-range
                format="HH:mm:ss"
                value-format="HH:mm:ss"
                v-model="companyInfoEntity.businessMorningArr"
                @change="changeBusinessMorning"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                placeholder="选择时间范围">
              </el-time-picker>
            </div>
            <div class="bussiness-item">
              <span class="item-span">下午</span>
              <el-time-picker
                is-range
                format="HH:mm:ss"
                value-format="HH:mm:ss"
                v-model="companyInfoEntity.businessAfternoonArr"
                @change="changeBusinessAfternoon"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                placeholder="选择时间范围">
              </el-time-picker>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="营业收入" prop="operatingProfit">
          <el-input v-model="companyInfoEntity.operatingProfit" @keyup.native="changeCode('operatingProfit')"  placeholder="请输入销售额">
            <template slot="append">万元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="营业利润" prop="operatingIncome">
          <el-input v-model="companyInfoEntity.operatingIncome" @keyup.native="changeCode('operatingIncome')"  placeholder="请输入金额">
            <template slot="append">万元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="员工人数" prop="staffAmount">
          <el-input v-model="companyInfoEntity.staffAmount" @keyup.native="changeCode('staffAmount')"  placeholder="请输入当前员工人数">
            <template slot="append">人</template>
          </el-input>
        </el-form-item>
        <el-form-item label="参保人数" prop="insuredAmount">
          <el-input v-model="companyInfoEntity.insuredAmount" @keyup.native="changeCode('insuredAmount')"  placeholder="请输入当前参保人数">
            <template slot="append">人</template>
          </el-input>
        </el-form-item>
        <el-form-item label="所属行业" prop="industry">
          <el-select v-model="companyInfoEntity.industry" placeholder="请选择所属行业">
            <el-option
              v-for="item in industryList"
              :key="item.key"
              :label="item.value"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="企业办公点照片" prop="officeImageUrl">
          <Upload v-model="companyInfoEntity.officeImageUrl" buttonText="请上传.png/jpg" :size="true"></Upload>
          <el-image v-if='companyInfoEntity.officeImageUrl' :src="companyInfoEntity.officeImageUrl" style="width: 200px; margin: 10px auto;"></el-image>
        </el-form-item>

        <el-form-item label="贷款余额明细表" prop="loanBalanceUrl">
          <el-button style='width:128px' @click="downloadDoc">下载明细表模板</el-button>
          <Upload style="display: inline-block; margin-left:14px;" v-model="companyInfoEntity.loanBalanceUrl" buttonText="请上传.Excel" :size="true"></Upload>
          <el-button style='margin-left:14px;' v-if="companyInfoEntity.loanBalanceUrl && companyInfoEntity.loanBalanceUrl!='无'" @click="previewLook">预览</el-button>
          <el-radio-group style="display: inline-block; margin-left:20px;" v-model="companyInfoEntity.loanBalanceUrl" @change="changeRadio($event)">
            <el-radio label="无">无</el-radio>
          </el-radio-group>
          <span style="display:block;color:#f65248;font-size:12px">注：内容包含贷款名称、贷款金额、贷款到期时间、贷款银行或金融机构</span>
        </el-form-item>
      </el-form>
    </div>
    <!-- 操作弹窗 -->
    <Dialog
      :show="show"
      @dialogClose="show=false"
      :title="'温馨提示'"
      :img="showC.img"
      :content="showC.content"
      :btn="showC.btn"
      :btn2="showC.btn2"
    />
  </div>
</template>
<script>
import { sessionStore } from "@/utils/data-management";
import AreaTree from "../../profile/components/AreaTree";
import Dialog from "@/components/Dialog";
import publicFun from "@/utils/publicFunction.js";
import Upload from "@/components/Upload/UpLoad.vue";
export default {
  components: {
    AreaTree,
    Dialog,
    Upload
  },
  data() {
    return {
      userType: this.$route.query.userType, //2企业,3行政事业单位抵押贷款
      businessWeekOptions: [
        '周一',
        '周二',
        '周三',
        '周四',
        '周五',
        '周六',
        '周日'
      ],
      rules: {
        companyAddress: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        contactPerson: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        contactAddress: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        contactNumber: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        // unifiedCreditCode: [
        //   { required: true, message: '请输入', trigger: 'blur' }
        // ],
        establishTime: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        principalName: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        identityNumber: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        principalNumber: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        loanAmount: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        bankId: [
          { required: true, message: '请选择', trigger: 'blur' }
        ],
        mainBusiness: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        businessWeek: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        operatingProfit: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        operatingIncome: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        staffAmount: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        insuredAmount: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        industry: [
          { required: true, message: '请选择', trigger: 'blur' }
        ],
        officeImageUrl: [
          { required: true, message: '请上传', trigger: 'blur' }
        ],
        loanBalanceUrl: [
          { required: true, message: '请上传', trigger: 'blur' }
        ],
      },

      formData: {
        demandId:'', //项目id  从我的资产列表 route中带过来的参数
        demandName:'', //项目名称 从我的资产列表 route中带过来的参数
        businessType:'1', //业务类型 从我的资产列表 route中带过来的参数
        lenderId:'', // 贷款人id (关联企业id or 用户id)
        lenderName:'',//贷款人姓名
        bankId: '',//银行id
        loanBank: "",//贷款银行
        area: "",// 所属区域  $store.cityArea
      },
      companyInfoEntity: {
        companyName: "",
        companyAddress: "", //企业地址
        contactPerson: "", //联系人
        contactAddress: "", //联系人地址
        contactNumber: "", //联系人电话
        unifiedCreditCode: "", //统一信用代码证号
        establishTime: "", //成立时间
        principalName: "", //主要负责人姓名
        identityNumber: "", // 负责人身份证号码
        principalNumber: "", //负责人电话
        loanAmount: "", //申请贷款金额
        bankId:"", // 希望申请的银行id
        applyBank: "", //希望申请的银行名称
        mainBusiness: "", //企业主营业务
        businessWeekStart: '', //星期开始
        businessWeekEnd: '', //星期结束
        businessMorningArr: "", //上午时间数组
        businessAfternoonArr: "", //下午时间数组
        businessWeek: "", //星期
        businessMorning: "", //上午
        businessAfternoon: "", //下午
        startTime: "", //所选开始时间
        endTime:"", //所选结束时间
        operatingProfit: "",  // 营业利率，需求是要营业利润
        operatingIncome: "", // 营业收入
        staffAmount: "", //员工数量
        insuredAmount: "", //参保人数
        officeImageUrl: "", //企业办公点照片的url
        loanBalanceUrl: "", //贷款明细表的url
        industry: "" //所属行业
      },
      
      industryList: [], //下拉的行业列表
      bankList: [], //下拉的银行列表
      bankListIs: false, // 获取下拉银行列表状态

      show: false,
      showC: {
        content: "content",
        img: "uncertified.png",
        btn: "确定",
        btn2: "",
        type: 1 // 1-未完善 2-保存 3-提交 4-分享 5-人脸成功
      },

      // mortgageApprovalFileEntities: [
      //   {
      //     fileType: "Copy-of-business-license",
      //     fileAddr: "营业执照正本地址",
      //     fileName: "营业执照正副本",
      //     content: ""
      //   }
      // ],
      active: 0, // 侧栏选中
      info: {
        columnList: []
      },
      infoSelect: {},
      select: [], // 表格勾选
      total: null, // 合计
    };
  },
  created() {
    this.initInfo();
    this.getIndustryList(); 
    this.getBankList();
  },
  mounted () {
    this.$nextTick(_=>{
      this.checkCompanyInfo();
    })
  },
  methods: {
    // 获取营业星期
    changeBusinessWeek() {
      if (this.companyInfoEntity.businessWeekStart&&this.companyInfoEntity.businessWeekEnd) {
        this.companyInfoEntity.businessWeek = this.companyInfoEntity.businessWeekStart + '至' + this.companyInfoEntity.businessWeekEnd
      } else {
        this.companyInfoEntity.businessWeek = ''
      }
    },
    // 获取上午时间
    changeBusinessMorning(value) {
      if (value) {
        this.companyInfoEntity.businessMorning = value[0]+'-'+value[1]
      } else {
        this.companyInfoEntity.businessMorning = ''
      }
    },
    changeBusinessAfternoon(value) {
      if (value) {
        this.companyInfoEntity.businessAfternoon = value[0]+'-'+value[1]
      } else {
        this.companyInfoEntity.businessAfternoon = ''
      }
    },
    // 获取下拉所属行业列表数据
    getIndustryList(){
      this.$api.apply
        .getIndustryList({categoryName: "Industry" })
        .then(res=>{
          if(res.code == 1000){
            this.industryList = res.data;
          }
        })
        .catch();
    },
    // 获取下拉银行列表数据
    getBankList(){
      this.$api.apply.loanBankList({}).then(res=>{
        if(res.code == 1000){
          this.bankList=res.data
        }
      })
      .finally(() => {this.bankListIs = true})
    },

    // 查询企业已有的信息
    checkCompanyInfo(){
      if (sessionStore.get('companyInfo')) {
        this.companyInfoEntity = sessionStore.get('companyInfo')
        this.companyInfoEntity.bankId = this.companyInfoEntity.bankId.split(',')
        this.changeBank(this.companyInfoEntity.bankId);
        return
      }
      this.$api.apply.getCompanyInfo({id: this.$route.query.demandId}).then(res=>{
        if(res.code == 1000){
          // 将企业已有的信息赋值 到 this.companyInfoEntity
          this.companyInfoEntity.companyName = res.data.companyName; //企业名称
          this.companyInfoEntity.companyAddress = res.data.companyAddress; //企业地址
          this.companyInfoEntity.contactPerson = res.data.contactPerson; //联系人
          this.companyInfoEntity.contactAddress = res.data.contactAddress; //联系人地址
          this.companyInfoEntity.contactNumber = res.data.contactNumber; //联系人电话
          this.companyInfoEntity.unifiedCreditCode = res.data.unifiedCreditCode; //统一信用代码
          // this.companyInfoEntity.establishTime = new Date(res.data.establishTime); //成立时间
          this.companyInfoEntity.principalName = res.data.principalName; //主要负责人姓名
          this.companyInfoEntity.identityNumber = res.data.identityNumber; //负责人身份证
          this.companyInfoEntity.principalNumber = res.data.principalNumber; //负责人电话
          this.companyInfoEntity.loanAmount = res.data.loanAmount; //申请金额
          this.companyInfoEntity.mainBusiness = res.data.mainBusiness; //企业主营业务
          // this.companyInfoEntity.timeValue = [new Date(res.data.startTime), new Date(res.data.endTime)]; //时间段
          // this.companyInfoEntity.startTime = new Date(res.data.startTime); //开始时间
          // this.companyInfoEntity.endTime = new Date(res.data.endTime); //结束时间
          this.companyInfoEntity.operatingProfit = res.data.operatingProfit;// 营业利润
          this.companyInfoEntity.operatingIncome = res.data.operatingIncome; // 营业收入

          this.companyInfoEntity.staffAmount = res.data.staffAmount; //员工数量
          this.companyInfoEntity.insuredAmount = res.data.insuredAmount; //参保人数
          this.companyInfoEntity.officeImageUrl = res.data.officeImageUrl; // 企业办公点照片
          // this.companyInfoEntity.loanBalanceUrl = res.data.loanBalanceUrl; //贷款明细表
          // this.companyInfoEntity.industry = res.data.industry; // 所属行业
          if (res.data.bankId) {
            this.companyInfoEntity.bankId = res.data.bankId.split(','); // 银行id
            this.changeBank(this.companyInfoEntity.bankId);
          }
          this.companyInfoEntity.loanBankId = res.data.loanBankId ? res.data.loanBankId : '' // 前一次贷款时 选择的银行。用于第二次选择银行进行对比，如果还是选择此银行，会先弹框提示 该银行被驳回过一次。
        }
      })
      .catch();
    },
    // 从我的资产列表带入信息
    initInfo(){
      this.formData.demandId = this.$route.query.demandId; // this.$route.query
      this.formData.demandName = this.$route.query.demandName; // this.$route.query
      this.formData.businessType = this.$route.query.businessType; // this.$route.query

      this.formData.lenderId = this.$store.state.userInfo.id;
      this.formData.lenderName = this.$store.state.userInfo.name; //name commonRealName accountName
      this.formData.bankId = ''; // 第三步-选择的贷款银行id
      this.formData.loanBank = ''; // 第三步-选择的贷款银行名称

      // 初始化store中的数据 
      this.formData.area = this.$store.state.cityArea.areaConfigId;
      this.$store.commit("SET_COMPANY_FORMDATA", {});
    },

    // 下载明细表模板
    downloadDoc() {
      window.open("static/WYGP/贷款余额明细表.xlsx", "_blank");
    },
    // 切换明细表有无数据
    changeRadio(val) {},
    // 预览
    previewLook() {
      window.location.href = this.companyInfoEntity.loanBalanceUrl;
    },

    // 选择的希望申请的银行，根据id匹配银行名称
    changeBank(val){
      let arr = [];
      let time = setInterval(() => {
        if (this.bankListIs) {
          val.forEach(item => {
            let a = this.bankList.find(itemc => {
              return itemc.id == item;
            });
            arr.push(a.name);
          });
          this.companyInfoEntity.applyBank = arr;
          clearInterval(time)
        }
      }, 1000);
    },
    // 成立时间
    changeEstablishTime(val){
      if(val == null){
        this.companyInfoEntity.establishTime = '';
      }
    },
    // 将企业信息中的输入的内容 转为 数字类型
    changeCode(name) {
      this.$nextTick(() => {
        if(this.companyInfoEntity[`${name}`] != null){
         this.companyInfoEntity[`${name}`] = this.companyInfoEntity[`${name}`].replace(/[^\d.]/g, '');
        }
      })
    },

    // 企业信息采集的下一步按钮
    sumbitCompany(index){
      const that = this;

      // 1.先用表单验证，判断信息是否都填写
      this.$refs.formRef.validate(v=>{
        if(v){
          if (!this.companyInfoEntity.businessWeek||!this.companyInfoEntity.businessMorning||!this.companyInfoEntity.businessAfternoon) {
            return this.$message.error('营业时间段不能为空')
          }
          let midCompanyInfo = publicFun.lcDeepCopy(this.companyInfoEntity);
          midCompanyInfo.bankId = midCompanyInfo.bankId.toString();
          midCompanyInfo.applyBank = midCompanyInfo.applyBank.toString();

          // this.$set(this.formData, 'companyInfoEntity', midCompanyInfo); //接口联调后台系统时，失误将companyInfoEntity 改成了companyInfo， 为了快捷更改，先前端替换
          this.$set(this.formData, 'companyInfo', midCompanyInfo);
          
          if(index == 1){
            sessionStore.set('companyInfo', midCompanyInfo)
            // 01.将数据保存在session 和 store中
            sessionStore.set("companyFormData", this.formData);
            this.$store.commit("SET_COMPANY_FORMDATA", this.formData);

            // 02.跳转到下一个页面 companyLoanUpload
            this.$router.push({name: 'companyLoanUpload'})

            // this.$api.apply.addCompanyLoad(that.formData).then(res => {
            //   if (res.code == 1000) {
            //     that.show = true;
            //     that.showC = {
            //       img: "success.png",
            //       content: "保存成功，继续完善请从“首页-个人中心-我的资产”功能进入",
            //       btn: "确定",
            //       type: 2
            //     };
            //     setTimeout(() => {
            //       that.show = false;
            //       that.$router.push({name:'myAsset'})
            //     }, 1500);
            //   }
            // });
          }
        }
      })
    },




    // 1 选项  2 文本  3  数字  4 整数  5 日期 6 自动计算
    init() {
      this.$api.apply
        .getLoanInfo({})
        .then(res => {
          if (res.code == 1000) {
            this.info = res.data;
            // 初始化，排序表格对应index
            this.info.columnList.map(item => {
              // 分割 数量，单价，金额
              for (let i = 0; i < item.fieldList.length; i++) {
                if (item.fieldList[i].fieldName == "数量,单价,金额") {
                  let data = item.fieldList[i],
                    arr = [];
                  for (let j = 0; j < 3; j++) {
                    arr.push(JSON.parse(JSON.stringify(data)));
                  }
                  arr[0].fieldName = "数量";
                  arr[1].fieldName = "单价";
                  arr[2].fieldName = "金额";
                  item.fieldList = item.fieldList
                    .slice(0, i)
                    .concat(arr)
                    .concat(item.fieldList.slice(i + 1));
                }
              }
              // 栏目
              for (let i = 0; i < item.valueList.length; i++) {
                // 栏目数据
                let valueData = [];
                item.fieldList.map((list, index) => {
                  for (let j = 0; j < item.valueList[i].valueData.length; j++) {
                    // 行数据
                    if (
                      list.fieldId == item.valueList[i].valueData[j].fieldId
                    ) {
                      if (list.valueType == 2) {
                        let val = item.valueList[i].valueData[j].value.split(
                            ","
                          ),
                          id = item.valueList[i].valueData[j].fieldId;
                        if (list.fieldName == "数量") {
                          valueData.push({ fieldId: id, value: val[0] });
                        } else if (list.fieldName == "单价") {
                          valueData.push({ fieldId: id, value: val[1] });
                        } else {
                          valueData.push({ fieldId: id, value: val[2] });
                        }
                      } else {
                        valueData.push(item.valueList[i].valueData[j]);
                      }
                      return valueData;
                    }
                  }
                  if (valueData.length < index + 1) {
                    valueData.push({ fieldId: list.fieldId, value: "" });
                  }
                });
                item.valueList[i].valueData = valueData;
              }
            });
            // 获取初始选择器列表
            this.info.columnList[0].fieldList.map((item, index) => {
              if (index != 0 && item.fieldType == 1) {
                this.getSelect(item.fieldId);
              }
            });
          }
        })
        .catch();
    },
    // 选择列表
    getSelect(id) {
      if (this.infoSelect[`id${id}`]) return;
      this.$api.user.getInfoSelect(id).then(res => {
        if (res.code == 1000) {
          this.$set(this.infoSelect, `id${id}`, res.data);
        }
      });
    },
    // 输入数字，小数点后2位
    oneDecimal(value) {
      let e = value.target.value;
      e = e.replace(/[^\d.]/g, "");
      e = e.replace(/^\./g, "");
      e = e.replace(/\.{2,}/g, "");
      e = e
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      e = e.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
      if (e.indexOf(".") < 0 && e != "") {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        e = parseFloat(e);
      }
      value.target.value = e;
    },
    // 勾选表格
    handleSelectionChange(val) {
      this.select = val;
    },
    // 切换栏目
    changeList(index) {
      this.active = index;
      // 获取选择器选项
      this.info.columnList[this.active].fieldList.map((item, index) => {
        if (this.active == 0 && index == 0) {
          return;
        }
        if (item.fieldType == 1) {
          this.getSelect(item.fieldId);
        }
      });
      // 计算合计
      this.computeTotal();
      window.scrollTo(0, 0);
    },
    // 新增
    addData() {
      if (this.info.columnList.length < 1) return
      // 不允许新增
      if (
        !this.info.columnList[this.active].canNew &&
        this.info.columnList[this.active].valueList &&
        this.info.columnList[this.active].valueList.length > 0
      ) {
        return;
      }
      let list = {
        rowId: null,
        valueData: []
      };
      this.info.columnList[this.active].fieldList.map(item => {
        list.valueData.push({
          fieldId: item.fieldId,
          value: ""
        });
      });
      if (!this.info.columnList[this.active].valueList) {
        this.info.columnList[this.active].valueList = [];
      }
      this.info.columnList[this.active].valueList.push(list);
    },
    // 删除
    subData() {
      if (this.select.length < 1) {
        return this.$message.error("请先选择要删除的数据");
      }
      let ids = this.select.map(item => JSON.stringify(item.valueData));
      let data = this.info.columnList[this.active].valueList.filter(
        item => {
          let index = ids.indexOf(JSON.stringify(item.valueData));
          if (index != -1) {
            ids.splice(index, 1);
          } else {
            return item.valueData;
          }
        }
      );
      this.info.columnList[this.active].valueList = data;
      this.computeTotal();
    },
    // 数量*单价=价格计算
    computePrice(row, e, name, index) {
      // 行数据
      let data = this.info.columnList[this.active].valueList[row].valueData;
      if (name == "数量" && data[index + 1].value) {
        data[index + 2].value =
          Number(e.target.value) * Number(data[index + 1].value);
        this.computeTotal();
      }
      if (name == "单价" && data[index - 1].value) {
        data[index + 1].value =
          Number(e.target.value) * Number(data[index - 1].value);
        this.computeTotal();
      }
    },
    // 金额计算，合计计算
    computeTotal() {
      let type = 1, // 类型
        id = "", // 价格的id
        total = 0; // 合计
      this.total = 0;
      this.info.columnList[this.active].fieldList.map(item => {
        if (item.valueType == 2) {
          type = 1;
          id = item.fieldId;
        }
        if (item.valueType == 3) {
          type = 2;
          id = item.fieldId;
        }
      });
      if (id) {
        this.info.columnList[this.active].valueList.map(row => {
          let i = 0;
          row.valueData.map(item => {
            if (item.fieldId == id && type == 1) {
              i++;
              if (i == 3) {
                total += Number(item.value);
              }
            }
            if (item.fieldId == id && type == 2) {
              total += Number(item.value);
            }
          });
        });
      }
      this.total = total;
    },
    // 村组id
    getAreaId(v) {
      this.info.villagePermissionId = v
    },
    // 保存，提交
    sumbit(index) {
      if (this.info.approvalStatus == 2) {
        return this.$message.error("审核中，请勿重复提交，保存");
      }
      let ids = [],
        columnName = "",
        id = "";
      // 提交必填项
      if (index == 2) {
        this.info.columnList.map(item => {
          if (columnName) return
          // 非必填项过滤
          if (!item.isRequire && item.valueList.length < 1) return;
          // 必填项为空
          if (item.isRequire && item.valueList.length < 1) {
            return columnName = item.columnName
          }
          ids = item.fieldList.map(list => {
            if (list.isRequire) {
              return list.fieldId;
            }
          });
          if (ids.length > 0) {
            if (item.valueList.length < 1 && !columnName) {
              return (columnName = item.columnName);
            }
            item.valueList.map(list => {
              list.valueData.map(fieldId => {
                if (
                  ids.indexOf(fieldId.fieldId) != -1 &&
                  !fieldId.value &&
                  !id
                ) {
                  id = fieldId.fieldId;
                  columnName = item.columnName;
                }
              });
            });
          }
          if (columnName) {
            item.fieldList.map(list => {
              if (list.fieldId == id) {
                columnName += `的${list.fieldName}`;
              }
            });
          }
        });
      }
      if (columnName) {
        this.show = true;
        this.showC = {
          img: "uncertified.png",
          content: "还未填写完整，请继续完善",
          btn: "确定",
          type: 1
        };
        return;
        // return this.$message.error(`请填写${columnName}`);
      }
      delete this.info.approvalStatus;
      let newData = publicFun.lcDeepCopy(this.info);
      // 合并 数量，单价，金额
      newData.columnList.map(item => {
        // fieldName
        for (let i = 0; i < item.fieldList.length; i++) {
          if (item.fieldList[i].valueType == 2) {
            let data = item.fieldList[i];
            data.fieldName = "数量,单价,金额";
            item.fieldList = item.fieldList
              .slice(0, i)
              .concat([data])
              .concat(item.fieldList.slice(i + 3));
          }
        }
        // valueData
        for (let i = 0; i < item.valueList.length; i++) {
          item.fieldList.map((list, index) => {
            if (list.valueType == 2) {
              let row = item.valueList[i].valueData;
              let data = {
                fieldId: row[index].fieldId,
                value: `${row[index].value},${row[index + 1].value},${
                  row[index + 2].value
                }`
              };
              item.valueList[i].valueData = row
                .slice(0, index)
                .concat([data])
                .concat(row.slice(index + 3));
              return;
            }
          });
        }
      });
      let data = newData.columnList.map(item => {
        let obj = {
          columnId: item.columnId,
          id: item.id,
          valueList: item.valueList,
          zctUserId: item.zctUserId
        }
        Object.keys(obj).forEach(key => {
          if(!obj[key]) {
            delete obj[key]
          }
          if(key == 'valueList') {
            obj[key].map(item => {
              if(!item.rowId) {
                delete item.rowId
              }
            })
          }
        })
        return obj
      })
      // 保存, 提交
      if (index == 1) {
        this.$api.user.saveFarmersInfo(newData).then(res => {
          if (res.code == 1000) {
            this.show = true;
            this.showC = {
              img: "success.png",
              content: "保存成功，继续完善请从”首页-个人中心-信息采集”功能进入",
              btn: "确定",
              type: 2
            };
            setTimeout(() => {
              this.show = false;
            }, 1500);
          }
        });
      } else {
        this.$api.apply.getLoanApply({columnList: data}).then(res => {
          if (res.code == 1000) {
            this.$router.push('companyLoanUpload')
          }
        });
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.info {
  box-sizing: border-box;
  width: 1200px;
  padding: 0 34px;
  padding-bottom: 75px;
  margin: 30px auto 0;
  background: #fff;

  .head {
    height: 90px;
    margin-bottom: 37px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title {
      line-height: 20px;
      padding-left: 12px;
      font-family: PingFangSC-Semibold;
      font-size: 20px;
      color: #f65248;
      position: relative;
    }
    .title::before {
      content: "";
      width: 4px;
      height: 20px;
      position: absolute;
      left: 0;
      top: 0;
      background: #f65248;
    }
    .tool {
      display: flex;
      cursor: pointer;
      div {
        width: 88px;
        line-height: 30px;
        margin-left: 20px;
        text-align: center;
        color: #fff;
        background-image: linear-gradient(-135deg, #55607b 0%, #394259 100%);
        border-radius: 2px;
      }
      div:last-child {
        width: 136px;
        background-image: linear-gradient(-135deg, #ff7067 0%, #ef5147 100%);
      }
    }
  }

  .el-form {
    width: 900px;
    padding-left: 250px;
    margin: 20px auto;
    /deep/ .el-form-item {
      .el-input {
        width: 300px;
        input {
          height: 30px;
          background: rgba(255, 255, 255, 1);
          border-radius: 2px;
          border: 1px solid rgba(240, 240, 240, 1);
          // padding: 9px 10px;
        }
      }
      &.bank {
        .el-input {
          width: 180px;
          margin-right: 20px;
        }
      }
    }
    /deep/ .el-range-editor--mini.el-input__inner{
      width: 300px;
    }
    .bussiness-item {
      padding-bottom: 10px;
      .lr-padding {
        padding: 0 10px;
      }
      .item-span {
        padding-right: 10px;
      }
      /deep/ .el-input {
        width: 90px;
      }
      /deep/ .el-range-editor--mini.el-input__inner {
        width: 220px;
      }
    }
    .code {
      display: inline-block;
      width: 111px;
      line-height: 27px;
      margin-left: 10px;
      cursor: pointer;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      text-align: center;
      color: #007bff;
      border: 1px solid #007bff;
      border-radius: 2px;
    }
  }
}
</style>